import { Box, Paper, Typography } from "@material-ui/core";
import React from "react";

interface Props {}

export const FourZeroFour = (props: Props) => {
    return (
        <>
            <Paper elevation={1}>
                <Box padding={2} marginTop={2}>
                    <Typography variant="caption">404</Typography>
                </Box>
            </Paper>
        </>
    )
}